import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {STATUTELIMITATION} from '../../constants/MicroServiceConstants';
import {STATE, TYPE} from '../../constants/Lookup';

const initialData = {
  statuteLimitationData: {},
  statuteLimitationStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'statuteLimitation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchStatuteLimitationData: (state, action) => {
      state.statuteLimitationData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postStatuteData: (state, action) => {
      state.statuteLimitationStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetStatuteStatus: (state) => {
      state.statuteLimitationStatus = null;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStatuteLimitationData,
  fetchDropDownData,
  fetchStart,
  postStatuteData,
  resetStatuteStatus,
  fetchError,
  resetMsg,
} = slice.actions;

export const fetchStatuteLimitation = (stateId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [STATE, TYPE],
      }),
      httpGet(`${STATUTELIMITATION}/find/statutelimitation/${stateId}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const statuteLimitationData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (
          statuteLimitationData &&
          statuteLimitationData.status &&
          statuteLimitationData.status === 200
        ) {
          dispatch(fetchStatuteLimitationData(statuteLimitationData.response));
        } else {
          dispatch(fetchError(statuteLimitationData.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postStatuteInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${STATUTELIMITATION}/save`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postStatuteData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatuteLimitationStatus = () => {
  return (dispatch) => {
    dispatch(resetStatuteStatus());
  };
};
